import { render, staticRenderFns } from "./CustomerPrint.vue?vue&type=template&id=bb33eebc&scoped=true"
import script from "./CustomerPrint.vue?vue&type=script&lang=js"
export * from "./CustomerPrint.vue?vue&type=script&lang=js"
import style0 from "./CustomerPrint.vue?vue&type=style&index=0&id=bb33eebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb33eebc",
  null
  
)

export default component.exports